import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {closeModal, setCurrentStep, stepEnum} from '../IMEIDeviceRepairSlice';
import Title from '../Shared/Title';
import ScreenImage from './../images/screen.svg';
import {isMobile} from 'react-device-detect';

const ImeiHelp = (props) => {
  return (
    <div className="imeiHelp-popUp">
      <div className="top-content">
        <Title text={`איפה מוצאים את המספר הסידורי?`} subtext={`צריך להקיש #06#* מכל מכשיר`} />
        <span className="help-text">
        מספר ה-IMEI הראשון שמופיע{isMobile && <br />} הוא המספר הסידורי שלך
      </span>
      </div>
      <Image className="screen-image" src={ScreenImage} alt={'screen'} />
      <BtnSubmit text={'הבנתי, תודה'} onclick={() => props.closeModal()} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {deviceRepairData: state.iMEIDeviceRepair};
};

const mapDispatchToProps = {closeModal, setCurrentStep};

export default connect(mapStateToProps, mapDispatchToProps)(ImeiHelp);
